export default {
    type: "",
    data: {},
    fetchData: {},
    fetchPendingData:{},
    fetchlibraryData:{},
    weekly:{},
    error: ''
}